export default "__VITE_ASSET__CVjo2umL__"